export const layerSource = (map) => {
  map.addSource('pcalor', {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/pcalortest/{z}/{x}/{y}.pbf'
    ],
    'minzoom': 1,
    'maxzoom': 11
  });
  map.addSource('pcalorfiltro', {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/pcalorfiltro/{z}/{x}/{y}.pbf'
    ],
    'minzoom': 2,
    'maxzoom': 11
  });
  map.addSource('pcalortest', {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/tiles/pcalortest/{z}/{x}/{y}.pbf'
    ],
    'minzoom': 2,
    'maxzoom': 9
  });
  map.addSource('anptest', {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/anptest/{z}/{x}/{y}.pbf'
    ],
    'minzoom': 2,
    'maxzoom': 11
  });
  map.addSource('estadostest', {
    'type': 'vector',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/estadostest/{z}/{x}/{y}.pbf'
    ],
    'minzoom': 2,
    'maxzoom': 11
  });
  map.addSource('esri', {
    'type': 'raster',
    'tiles': [
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg'
    ],
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 16
  });
  map.addSource('googleHybrid', {
    'type': 'raster',
    'tiles': [
      'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}'
    ],
    'tileSize': 256,
    'attribution': 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
    'minzoom': 0,
    'maxzoom': 20
  });

  map.addSource('open', {
    'type': 'raster',
    'tiles': [
      'http://a.tile.osm.org/{z}/{x}/{y}.png','http://b.tile.osm.org/{z}/{x}/{y}.png','http://c.tile.osm.org/{z}/{x}/{y}.png'
    ],
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 16
  });
  map.addSource('conabio', {
    'type': 'raster',
    'tiles': [
      'http://ssig.conabio.gob.mx/erdas-iws/ogc/wmts/conabio?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=mex&STYLE=default&FORMAT=image/png&TILEMATRIXSET=OGC:1.0:GoogleMapsCompatible&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'
    ],
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 16
  });
  map.addSource('humedadIdHrgbA', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/humedadIdHrgbA2/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 10
  });
  //catFinalNDVI
  map.addSource('catFinalNDVI', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/catFinalNDVI2/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 10
  });
  //pcalorxcluster
  map.addSource('puntosxcluster', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/puntosxcluster/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('puntosestables', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/puntosestables/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('pCalor10pc1hr', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/pCalor10pc1hr/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('heatmap24h', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/heatmap24h/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('stacker24h', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/stacker24h/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('modisFalseColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/modisFalseColor2/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('modisTrueColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/modisTrueColor2/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('viirsFalseColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/viirsFalseColor/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('viirsTrueColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/viirsTrueColor/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  //viirsNight
  map.addSource('viirsNight', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/viirsNight/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goesFalseColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goesFalseColor/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goesTrueColor', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goesTrueColor/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goes_mh', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goes_mh/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goes_mh_qa', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goes_mh_qa/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goes_winds', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goes_winds/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goes_glm', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goes_glm/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('goes_rain', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/goes_rain/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  map.addSource('burnday', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/burnday/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  //aq2000_2019
  map.addSource('aq2000_2019', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/aq2000_2019/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('aq2000_2019ca', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/aq2000_2019ca/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('nalcms', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/nalcms/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('indiceAmenazaReclass', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/indiceAmenazaReclass/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('lucesEstablesMex', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/lucesEstablesMex/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('lucesRasterCA', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/lucesRasterCA/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('anp2', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/anp/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('centrosRegionales', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/centrosRegionales/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('ap2014dissv2', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/ap2014dissv2/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('paisEstado', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/paisEstado/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 14
  });
  map.addSource('pressure', {
    'type': 'raster',
    "scheme": "tms",
    'tiles': [
      'http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com/incendios/tiles/pressure/{z}/{x}/{y}.png'
    ],
    'tms':false,
    'tileSize': 256,
    'attribution': '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    'minzoom': 0,
    'maxzoom': 12
  });
  
  return map
}